import { useQuery } from '@tanstack/react-query'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth, useTenant } from '../index'

const { env } = window

const useAffiliations = () => {
  const { loggedIn, securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { tenant } = useTenant()

  const getAffiliations = async (tenantId) => {
    const fetchFn = loggedIn ? securedFetch : fetch
    const url = encodeURI(
      loggedIn
        ? `${env.apiUrl}/tenants/${tenantId}/userAffiliations`
        : `${env.publicApiUrl}/tenants/${tenantId}/affiliations`
    )
    const response = await fetchFn(url)
    await handleResponse(response)
    return response.json()
  }

  const query = useQuery({
    queryKey: ['affiliations', tenant?.id, loggedIn],
    queryFn: () => getAffiliations(tenant?.id),
    enabled: !!tenant
  })

  query.isError && handleError(query.error, 'Error getting affiliations')

  return {
    affiliations: query.data
  }
}

export { useAffiliations }
